export const clinicKeys = {
  base: () => ["clinic"],
  clinic: () => [...clinicKeys.base(), "clinic"],
  billData: () => [...clinicKeys.base(), "billData"],
  apiIntegration: () => [...clinicKeys.base(), "apiIntegration"],
  billDataNew: () => [...clinicKeys.base(), "billDataNew"],
  globalPatientSettings: () => [...clinicKeys.base(), "globalPatientSettings"],
  billingProfile: () => [...clinicKeys.base(), "billingProfile"],
  dietitians: () => [...clinicKeys.base(), "dietitians"],
  dietitian: (id: number) => [...clinicKeys.base(), "dietitian", id],
  clinicBlock: () => [...clinicKeys.base(), "clinicBlock"],
  featureUsage: (featureId: number) => [
    ...clinicKeys.base(),
    "featureUsage",
    featureId,
  ],
  usagePatients: () => [...clinicKeys.base(), "usagePatients"],
  usageDietitians: () => [...clinicKeys.base(), "usageDietitians"],
};
